/* eslint-disable react/prop-types */

import GlobalTitle from "../shared/GlobalTitle";
import RoundedButton from "../ui/RoundedButton";

const AcademicCalendar = ({ data }) => {
  return (
    <div className="lg:pl-8">
      <GlobalTitle title={data.title} />
      <p className="pb-5 lg:pb-10">{data.description}</p>
      <RoundedButton href="/academics/academic-calender">
        View Academic Calendars
      </RoundedButton>
    </div>
  );
};

export default AcademicCalendar;
